function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M63.52 59.4855H33.5143V90.5083H3V122.048H33.5143V150.486H63.52V122.048H92V90.5083H63.52V59.4855Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M87.0542 41.2437C96.8704 44.6949 104.125 47.2457 105.54 47.31C107.318 47.3908 115.623 44.3704 126.566 40.3904C150.949 31.522 188.432 17.8895 196 23.1873C196 32.234 165.592 57.3956 145.758 73.8076C136.744 81.2659 129.914 86.9173 129.114 88.4282C128.276 90.0118 127.053 97.8166 125.42 108.235C121.4 133.886 114.897 175.379 105.54 178.888C99.7322 173.08 95.639 154.199 92.4097 136.011C100.279 135.943 106.636 129.571 106.636 121.72V90.5833C106.636 82.69 100.21 76.2912 92.2825 76.2912H77.9285V59.9574C77.9285 52.064 71.502 45.6652 63.5745 45.6652H33.8593C23.512 35.0369 15.9629 26.2344 16.7247 23.1873C22.3495 18.4945 62.63 32.6565 87.0542 41.2437ZM89.969 121.72H92.2825V90.5833H78.944C82.3133 94.2759 84.602 97.1616 85.255 98.8448C86.7179 102.615 88.2222 111.325 89.969 121.72ZM63.5745 74.9483C60.8779 72.3038 58.0625 69.5645 55.2083 66.7875C52.8834 64.5255 50.5328 62.2385 48.1999 59.9574H63.5745V74.9483Z",
  fill: "currentColor"
});

function SvgAmplify(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmplify);
export default __webpack_public_path__ + "static/media/amplify.2e4fc371.svg";
export { ForwardRef as ReactComponent };